<template>
    <div>

        <b-breadcrumb>
            <b-breadcrumb-item to="/">
                <i class="fa fa-home"></i>
                Home
            </b-breadcrumb-item>
            <b-breadcrumb-item to="/Oracle/Accounts">Oracle</b-breadcrumb-item>
            <b-breadcrumb-item to="/Oracle/ModuleRoles">Roles</b-breadcrumb-item>
            <b-breadcrumb-item active>Add</b-breadcrumb-item>
        </b-breadcrumb>

        <AppLoadingContainer :predicate="!isLoaded">
            <form @submit.prevent="onSubmit">
                <div class="card">
                    <div class="bg-dark card-header text-white">Create New Oracle Module Role</div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6 col-sm-12 form-group">
                                <label for="Role">Role Name</label>
                                <input :class="{'is-invalid': !$v.moduleRole.role.required}" autocomplete="off"
                                       class="form-control"
                                       placeholder="Role Name" v-model="moduleRole.role"/>
                                <span class="invalid-feedback"
                                      v-if="!$v.moduleRole.role.required">Field is required</span>
                            </div>
                            <div class="col-md-6 form-group">
                                <label for="OrganizationId">Organization</label>
                                <select :class="{'is-invalid': $v.moduleRole.organizationId.$invalid}"
                                        class="form-control"
                                        v-model="moduleRole.organizationId">
                                    <option :value="null" disabled>-- Select Organization --</option>
                                    <option :key="org.id" :value="org.id" v-for="org in organizationList">
                                        {{org.code+"-"+org.name}}
                                    </option>
                                </select>
                                <span class="invalid-feedback" v-if="!$v.moduleRole.organizationId.required">Field is required</span>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer d-print-none text-right">
                        <button :disabled="isSubmitting" class="btn btn-primary" type="submit">Save</button>
                        <RouterLink :to="{name:'OracleModuleRoles'}" class="btn btn-danger">Back</RouterLink>
                    </div>
                </div>
            </form>
        </AppLoadingContainer>

    </div>
</template>

<script>
    import {required} from "vuelidate/lib/validators";
    import {ToastType} from "@/services/models/shared/ToastType";
    import OracleService from "@/services/OracleService";
    import OrganizationService from "@/services/OrganizationService";
    import AppLoadingContainer from "@/components/shared/AppLoadingContainer";

    export default {
        components: {
            AppLoadingContainer
        },
        data() {
            return {
                isLoaded: false,
                isSubmitting: false,
                organizationList: [],
                moduleRole: {
                    role: null,
                    organizationId: null,
                },
            }
        },
        methods: {
            /**
             * @description Creates a new module role and redirects if successful
             */
            onSubmit() {
                const vm = this;

                // stop here if form is invalid
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                vm.isSubmitting = true;
                OracleService.addModuleRole(vm.moduleRole).then(() => {
                    vm.alert(ToastType.Success, `The module role code '${vm.moduleRole.role} was successfully created.`);

                    // Redirect to the general codes page
                    vm.$router.replace({name: 'OracleModuleRoles'})
                }).catch(function (error) {
                    vm.alert(ToastType.Danger, error.response.statusText);
                }).finally(() => {
                    vm.isSubmitting = false;
                });
            }
        },
        created() {
            const vm = this;

            // Retrieving all organizations
            OrganizationService.getAllOrganizations()
                .then(function (responses) {
                    vm.organizationList = responses;
                }).catch((error) => {
                vm.alert(ToastType.Danger, error.response.statusText);

            }).finally(() => vm.isLoaded = true)
        },
        validations: {
            moduleRole: {
                role: {
                    required,
                },
                organizationId: {
                    required
                }
            }
        }
    }
</script>
